import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const locationApi = createApi({
  reducerPath: 'locationApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Location'],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getListLocation: builder.query({
      query: (params) => ({
        url: NetWork.location,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'Location', id: 'LIST' }] : [])
    }),
    getLocationById: builder.query({
      query: (params: { locationId: number }) => ({
        url: NetWork.locationId(params.locationId),
        method: GET
      })
    }),
    addLocation: builder.mutation({
      query: (data) => ({
        url: NetWork.location,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    }),
    updateLocation: builder.mutation({
      query: (data: { id: number; [key: string]: unknown }) => ({
        url: NetWork.locationId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    }),
    changeIsActiveLocation: builder.mutation({
      query: (data: { locationId: number; params: { isActive: boolean } }) => ({
        url: NetWork.locationId(data.locationId),
        method: PATCH,
        params: data.params
      }),
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    }),
    deleteLocation: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.location,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'Location', id: 'LIST' }]
    })
  })
})

export const {
  useGetListLocationQuery,
  useLazyGetListLocationQuery,
  useGetLocationByIdQuery,
  useAddLocationMutation,
  useUpdateLocationMutation,
  useChangeIsActiveLocationMutation,
  useDeleteLocationMutation
} = locationApi
